/**
 * @generated SignedSource<<8fc24bcea78df95e03165a5a6c7e0de7>>
 * @relayHash 43c8facf0a4a471b17ec8396772b5bcf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43c8facf0a4a471b17ec8396772b5bcf

import { ConcreteRequest } from 'relay-runtime';
export type BetterDoc = "ALLOWED" | "CONDITION_PACKAGE" | "NOT_ALLOWED" | "REQUIRED";
export type BetterDocConsultationDetail = "DIAGNOSIS_CODE" | "SPECIALTY";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type useDeBetterDocUsageForConsultationQuery$variables = {
  diagnosisCode?: string | null;
  effectivePointOfCare: PointOfCareType;
  patientId: string;
  specialtyId?: string | null;
};
export type useDeBetterDocUsageForConsultationQuery$data = {
  readonly betterDocUsageForConsultation: BetterDoc;
  readonly missingConsultationDetailsThatCanChangeBetterDocUsage: ReadonlyArray<BetterDocConsultationDetail>;
};
export type useDeBetterDocUsageForConsultationQuery = {
  response: useDeBetterDocUsageForConsultationQuery$data;
  variables: useDeBetterDocUsageForConsultationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "diagnosisCode"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectivePointOfCare"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialtyId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "diagnosisCode",
    "variableName": "diagnosisCode"
  },
  {
    "kind": "Variable",
    "name": "effectivePointOfCare",
    "variableName": "effectivePointOfCare"
  },
  {
    "kind": "Variable",
    "name": "patientId",
    "variableName": "patientId"
  },
  {
    "kind": "Variable",
    "name": "specialtyId",
    "variableName": "specialtyId"
  }
],
v5 = [
  {
    "alias": "betterDocUsageForConsultation",
    "args": (v4/*:: as any*/),
    "kind": "ScalarField",
    "name": "de_betterDocUsageForConsultation",
    "storageKey": null
  },
  {
    "alias": "missingConsultationDetailsThatCanChangeBetterDocUsage",
    "args": (v4/*:: as any*/),
    "kind": "ScalarField",
    "name": "de_missingConsultationDetailsThatCanChangeBetterDocUsage",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeBetterDocUsageForConsultationQuery",
    "selections": (v5/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useDeBetterDocUsageForConsultationQuery",
    "selections": (v5/*:: as any*/)
  },
  "params": {
    "id": "43c8facf0a4a471b17ec8396772b5bcf",
    "metadata": {},
    "name": "useDeBetterDocUsageForConsultationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bebd5dea9cbe063741815f162c909f00";

export default node;
